import { render, staticRenderFns } from "./FormAccessRequestTableComponent.vue?vue&type=template&id=915242ac&lang=pug"
import script from "./FormAccessRequestTableComponent.vue?vue&type=script&lang=js"
export * from "./FormAccessRequestTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('915242ac')) {
      api.createRecord('915242ac', component.options)
    } else {
      api.reload('915242ac', component.options)
    }
    module.hot.accept("./FormAccessRequestTableComponent.vue?vue&type=template&id=915242ac&lang=pug", function () {
      api.rerender('915242ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/components/FormAccessRequestTableComponent.vue"
export default component.exports